import React, { FC, useEffect, useRef, useState } from 'react';
import { HeadingBlock } from '@design-system/heading-block';
import { FinishProductDifferences } from '@phx-husky/cc-finish-product-differences';

import { FinishExploreOurProductsMock } from '../../../../../custom-components-mocks';
import { FinishExploreOurProductsProps } from './models';

import './FinishExploreOurProducts.scss';

const FinishExploreOurProducts: FC<FinishExploreOurProductsProps> = ({
  exploreProductsTitle,
  productsDisclamer,
  closedPanelText,
  openedPanelText,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    if (isOpen) {
      el.style.height = `${el.scrollHeight}px`;
    } else {
      el.style.height = '0px';
    }
  }, [isOpen]);

  return (
    <div className="finish-explore-our-products cds-section cds-page-block cds-section--transparent-mode">
      <div className="cds-container cds-container--max-grid">
        <HeadingBlock
          className="products-title"
          headline={exploreProductsTitle}
          headlineTag="h2"
          align="center"
        />
        <div className="products-cntrl">
          <button
            type="button"
            className={`cds-btn load-more-block__button cds-btn--subtle cds-btn--subtle-large products-collapse-btn ${
              isOpen ? 'is-open' : ''
            }`}
            onClick={() => setIsOpen((prev) => !prev)}
            aria-expanded={isOpen}
          >
            {isOpen ? openedPanelText : closedPanelText}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M17.3616 5.41659L10.4166 12.1661L3.47159 5.41659L2.08325 6.62659L10.4166 14.5833L18.7499 6.62659L17.3616 5.41659Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
        <div ref={contentRef} className={`products-collapse-content ${isOpen ? 'is-open' : ''}`}>
          <div className="products-collapse-inner">
            <FinishProductDifferences {...FinishExploreOurProductsMock} />
          </div>
        </div>

        <p className="products-disclamer cds-typography">{productsDisclamer}</p>
      </div>
    </div>
  );
};

export default FinishExploreOurProducts;
